import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {AuthService} from "../services/auth.service";
import {Router, ActivatedRoute} from "@angular/router";
import { AlertService } from 'app/shared/services/alert.service';
import { AmplifyService } from 'aws-amplify-angular';
import { Subscription } from 'rxjs/Subscription';
import { DacConfig } from 'app/shared/services/dac-config.service';
@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit,OnDestroy {

  private _username:string;
  public password:string;
  public forgotPasswordCode:string;
  public newPassword:string;
  private return: string = '';
  public showSignIn:boolean;
  public isAuthenticating:boolean;
  private user:any;
  private _authState:string;
  private _authSubscription:Subscription;
  private _forgotPasswordCodeSent:boolean;

  public showRegistrationLink:boolean;

  @Input() disableRegistration:boolean;

  constructor(
     private authService:AuthService
    ,private router:Router
    ,private alertService: AlertService
    ,private route:ActivatedRoute
    ,private dacConfig:DacConfig
    ,private amplifyService:AmplifyService
  ) { 
    this._forgotPasswordCodeSent = false;
    this.showSignIn = true;
    this.isAuthenticating = false;
    this._authSubscription = this.amplifyService.authStateChange$.subscribe(authState => {
      this._authState = authState.state;
      // we don't want to show the greetings while we log a user in.
      this.showSignIn = authState.state === 'signIn' || authState.state === 'signedIn';
      this.user = authState.user;

      if (authState.state === 'signedIn') {
        this.authenticateCognito(); // make sure we are setup in our session on the server...
      }
    });
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => this.return = params['return'] || '/admin/');
  }

  ngOnDestroy() {
    if (this._authSubscription) {
      this._authSubscription.unsubscribe();
    }
  }
  
  handleSubmit(event:KeyboardEvent) {
    if (event && event.charCode === 13) {
      this.login();
    }
  }

  get username() {
    return this._username;
  }

  set username(v:string) {
    this._username = v ? v.toLowerCase() : "";
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  get authState() {
    return this._authState;
  }

  // FOLLOWING FUNCTIONALITY FOR Forgot Password
  get sentCode() {
    return this._forgotPasswordCodeSent;
  }

  triggerForgotPassword(evt:Event) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    this._forgotPasswordCodeSent = false;
    this.amplifyService.setAuthState({state: 'forgotPassword', user: this.user});
    return false;
  }
  goBackToSignIn(evt:Event) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    this.amplifyService.setAuthState({state: 'signIn', user: this.user});
    return false;
  }
  sendForgotPasswordCode(evt:Event) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    let username = this.username;
    if (!username) {
      this.alertService.error("You must enter an email address");
      return;
    }

    // we first attempt to migrate the user before initiating the forgot password
    this.isAuthenticating = true;
    this.authService.migrateCognito(username)
    .then(() => {
      this.amplifyService
        .auth()
        .forgotPassword(username)
        .then(() => {
          this._forgotPasswordCodeSent = true;
          this.isAuthenticating = false;
          this.alertService.info("Confirmation Code sent to the email address you entered");
        })
        .catch((err) => {
            this.isAuthenticating = false;
            this.alertService.error(err.message);
            console.error(err);
            this._forgotPasswordCodeSent = false;
        });
    })
    .catch(err => {
      this.isAuthenticating = false;
      this.alertService.error("An error occurred.  Please check your internet connection or contact support");
      console.error(err);
      this._forgotPasswordCodeSent = false;
    });
    return false;
  }
  submitForgotPassword() {
    if (!this.forgotPasswordCode) {
      this.alertService.error("Missing Code Confirmation");
      return;
    }
    if (!this.newPassword) {
      this.alertService.error("Missing New Password");
      return;
    }
    let errors = this.validatePasswordChange(this.newPassword);
    if (errors.length) {
      this.alertService.error(errors.join(""));
      return;
    }

    this.amplifyService.auth()
    .forgotPasswordSubmit(this.username, this.forgotPasswordCode, this.newPassword)
    .then(() => {
      this.newPassword = null;
      this.password = null;
      this.user = {username: this.username};
      this.amplifyService.setAuthState({state: 'signIn', user: this.user});
      this.alertService.success("Password reset.  Please login with your new credentials");
    })
    .catch(err => {  
      this.alertService.error(err.message);
    })
  }

  private validatePasswordChange(password:string) {
    let passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
    let errors = [];
    if (!password || password.length < 8) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[0-9]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[A-Z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[a-z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    return errors;
  }

  // Functionality for require new password
  submitNewPassword() {
    if (!this.newPassword) {
      this.alertService.error("Missing Password");
      return;
    }
    let errors = this.validatePasswordChange(this.newPassword);
    if (errors.length) {
      this.alertService.error(errors.join(""));
      return;
    }

    var user = this.user;
    var requiredAttributes = user.challengeParam.requiredAttributes;
    this.isAuthenticating = true;
    this.amplifyService
        .auth()
        .completeNewPassword(user, this.newPassword, requiredAttributes)
        .then(() => {
          this.password = null;
          this.newPassword = null;
          this.isAuthenticating = false;
            this.alertService.success("Password has been updated.  Please login with your new credentials");
            this.amplifyService.setAuthState({ state: 'signIn', user: user });
        })
        .catch((err) => {
          this.isAuthenticating = false;
          this.alertService.error(err.message);
        });
  }

  // Functionality for Sign In
  login() {
    if (!this.username || this.username.trim() === "" || 
        !this.password || this.password.trim() === "") {
      this.alertService.error("Your email and password cannot be empty");
      return;
    }
    let username = this.username.trim();
    let password = this.password.trim();
    this.isAuthenticating = true;
    // TODO: stephen shouldn't this all be put into auth.server.ts?
    this.amplifyService
          .auth()
          .signIn(username, password)
          .then((user) => {
            this.isAuthenticating = false;
          if (user['challengeName'] === 'SMS_MFA' ||
              user['challengeName'] === 'SOFTWARE_TOKEN_MFA') {
              this.amplifyService.setAuthState({ state: 'confirmSignIn', user: user });
          }
          else if (user['challengeName'] === 'NEW_PASSWORD_REQUIRED') {
              this.password = ""; // clear out our password, so its not populated when the password is reset.
              this.amplifyService.setAuthState({
                  state: 'requireNewPassword',
                  user: user,
              });
          }
          else if (user['challengeName'] === 'CUSTOM_CHALLENGE' &&
              user.challengeParam &&
              user.challengeParam.trigger === 'true') {
              this.amplifyService.setAuthState({
                  state: 'customConfirmSignIn',
                  user: user,
              });
          }
      })
      .catch((error) => {
        if (error && error.code == "NotAuthorizedException") {
          // we will check for a user that might not have migrated over...
          this.migrationAuthenticate();
        }
        else {
          this.isAuthenticating = false;
          this.alertService.error("There was an error in communicating with the server.  Please try again or contact support");
        }
        console.error(error);
      });
  }

  private authenticateCognito() {
    // 
    this.authService.authenticateCognito(this.user)
    .then((user) => {
      this.password = "";
      // either going back to the original requested url or going to the dashboard.
      this.router.navigateByUrl(this.return);
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("There was an error in authenticating your session.  You may need to clear your browser cookies and try again or contact customer support");
      this.alertService.error(error);
    })
  }

  private migrationAuthenticate() {
    this.authService.authenticate(this.username, this.password)
    .then((clientId) => {
      this.password = "";
      // either going back to the original requested url or going to the dashboard.
      this.router.navigateByUrl(this.return);
    })
    // TODO: stephen is this a leaky abstraction??
    .catch((error) => {
      this.isAuthenticating = false;
      this.alertService.error(error);
      console.error(error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/admin-login/admin-login.component.ts